import React from 'react';
import {
  OrderStatusContent,
  OrderReviewContent,
  ActionsContent,
  type ModalTab,
  type ModalScanFile
} from './OrderModalTabs';
import { ManagerOrderReviewRow } from "../../../../Interfaces/ManagerOrderReviewRow";
import { ManagerOrderRow } from '../../../../Interfaces/MangerOrderRow';
import { getStatusStyle } from "../../../../utils/statusStyles";

interface ScanFile {
  path: string;
  name: string;
}

interface OrderDetailsModalProps {
  isOpen: boolean;
  orderDetails: any;
  activeTab: ModalTab;
  loading: boolean;
  orderReview: ManagerOrderReviewRow[];
  scans: ScanFile[];
  cancelReason: string;
  designers: any[];
  millings: any[];
  deliveryPartners: any[];
  isDesignAcceptanceOverdue: boolean;
  isMillingAcceptanceOverdue: boolean;
  isDesignerRejected: boolean;
  isMillingRejected: boolean;
  selectedOrder: ManagerOrderRow | null;
  onClose: () => void;
  onTabChange: (tab: ModalTab) => void;
  onViewStl: (scan: ScanFile) => void;
  onCancelOrder: (caseId: number, reason: string) => void;
  onCancelReasonChange: (reason: string) => void;
  onReassignDesigner: (
    caseId: number,
    designerId: number
  ) => Promise<boolean> | void;

  onReassignMilling: (
    caseId: number,
    millingId: number
  ) => Promise<boolean> | void;
   onReassignDelivery: (
    caseId: number,
    deliveryPartnerId: number
  ) => Promise<boolean> | void;
}
const STATUS_ITEMS = [
  { key: 'Active Orders', label: 'Active Orders', className: 'bgnone', icon: null, iconClass: null },
  { key: 'Awaiting Response', label: 'Awaiting Response', className: 'warning', icon: '/awaiting.png', iconClass: null },
  { key: 'Needs Attention', label: 'Need Attention', className: 'danger', icon: '/needsattantion2.png', iconClass: null },
  { key: 'On Time', label: 'On Time', className: 'bg-white-ontime', icon: '/completed.png', iconClass: null },
  { key: 'Completed', label: 'Completed', className: 'success', icon: null, iconClass: 'bi bi-check-circle-fill completed-icon' },
  { key: 'Cancelled', label: 'Cancelled', className: 'cancelled', icon: null, iconClass: 'bi bi-dash-circle-fill' },
] as const;
const TAB_CONFIGS = [
  { id: 'order-status' as ModalTab, label: 'Order Status' },
  { id: 'order-review' as ModalTab, label: 'Order Details' },
  { id: 'actions' as ModalTab, label: 'Actions' },
] as const;

export const OrderDetailsModal: React.FC<OrderDetailsModalProps> = ({
  isOpen,
  orderDetails,
  activeTab,
  loading,
  orderReview,
  scans,
  cancelReason,
  isDesignAcceptanceOverdue,
  isMillingAcceptanceOverdue,
  isDesignerRejected,
  isMillingRejected,
  designers,
  millings,
  deliveryPartners,
  selectedOrder,
  onClose,
  onTabChange,
  onViewStl,
  onReassignDesigner,
  onReassignMilling,
    onReassignDelivery,
  onCancelOrder,
  onCancelReasonChange,

}) => {
  if (!isOpen) return null;

  return (

    <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered " style={{ maxWidth: "980px" }}>
        <div className="modal-content custom-modal-padding15px" style={{ minHeight: "580px" }}>
          {/* Modal Header */}
          <ModalHeader
            orderId={orderDetails?.orderID}
            onClose={onClose}
          />

          {/* Dentist Approval Section */}
          {/* <DentistApprovalSection /> */}
          <DentistApprovalSection
            approvalStatus={orderDetails?.approvalStatus}
            expectedDelivery={selectedOrder?.expectedDelivery}
            status={selectedOrder?.status}
          />

          {/* Tabs Navigation */}
          <TabsNavigation
            activeTab={activeTab}
            onTabChange={onTabChange}
          />

          {/* Modal Body */}
          <ModalBody
            loading={loading}
            activeTab={activeTab}
            orderDetails={orderDetails}
            orderReview={orderReview}
            scans={scans}
            cancelReason={cancelReason}
            isDesignAcceptanceOverdue={isDesignAcceptanceOverdue}
            isMillingAcceptanceOverdue={isMillingAcceptanceOverdue}
            isDesignerRejected={isDesignerRejected}
            isMillingRejected={isMillingRejected}
            selectedOrder={selectedOrder}
            designers={designers}
            millings={millings}
            deliveryPartners={deliveryPartners}
            onViewStl={onViewStl}
            onReassignDesigner={onReassignDesigner}
            onReassignMilling={onReassignMilling}
             onReassignDelivery={onReassignDelivery}
            onCancelOrder={onCancelOrder}
            onCancelReasonChange={onCancelReasonChange}
          />
        </div>
      </div>
    </div>
  );
};

// Sub-components for better organization

interface ModalHeaderProps {
  orderId: string;
  onClose: () => void;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ orderId, onClose }) => (
  <div className="modal-header manager-modal-header">
    <h6 className="modal-title">Order ID: {orderId || "--"}</h6>
    <button
      type="button"
      className="btn-close custom-close-btn"
      onClick={onClose}
      aria-label="Close"
    >
      <i className="bi bi-x customcross"></i>
    </button>
  </div>
);

interface DentistApprovalSectionProps {
  approvalStatus?: string;
  expectedDelivery?: string | number;
  status?: string;
}

const DentistApprovalSection: React.FC<DentistApprovalSectionProps> = ({
  approvalStatus,
  expectedDelivery,
  status,
}) => {
  const style = getStatusStyle(status || "");
  const item = STATUS_ITEMS.find(
    s => s.key.toLowerCase() === status?.toLowerCase());

  return (
    <div className="dentist-approval-pending">

      {/* 1️⃣ Approval Status */}
      <div className="dentist-approval">
        {approvalStatus || "--"}
      </div>

      <div className="d-flex justify-content-between align-items-center">

        {/* 2️⃣ Time */}
        <div className="Time-section mx-2">
          Time:-{" "}
          {expectedDelivery}
        </div>

        {/* 3️⃣ Status Badge */}
        <div className="status-item">
          <span
            className={`status-badge ${item?.className || ""}`}
            style={{
              ...style,
              padding: "3px 8px",
              borderRadius: "5px",
              fontSize: "13px",
              display: "inline-flex",
              alignItems: "center",
              gap: "5px",
              whiteSpace: "nowrap"
            }}
          >
            {item?.icon && (
              <img src={item.icon} alt="" className="status-icon" />
            )}

            {item?.iconClass && (
              <i className={item.iconClass}></i>
            )}

            {item?.label || status || "Unknown"}
          </span>
        </div>
      </div>
    </div>
  );
};

// const DentistApprovalSection: React.FC = () => (
//   <div className="dentist-approval-pending">
//     <div className="dentist-approval">Dentist Approval Pending</div>
//     <div className="d-flex justify-content-between">
//       <div className="Time-section mx-2">Time:- 2hrs 25 min</div>
//       <div className="status-item">
//         <span className="status-badge danger">
//           <img src="/needsattantion.png" alt="" className="status-icon" />
//           Need Attention
//         </span>
//       </div>
//     </div>
//   </div>
// );

interface TabsNavigationProps {
  activeTab: ModalTab;
  onTabChange: (tab: ModalTab) => void;
}

const TabsNavigation: React.FC<TabsNavigationProps> = ({ activeTab, onTabChange }) => (
  <div className="d-flex border-bottom tab-border-bottom-section mx-2 pt-2">
    {TAB_CONFIGS.map((tab) => (
      <button
        key={tab.id}
        className={`btn order-status-text btn-link ${activeTab === tab.id ? "active-tab-section" : ""}`}
        onClick={() => onTabChange(tab.id)}
        type="button"
      >
        {tab.label}
      </button>
    ))}
  </div>
);

interface ModalBodyProps {
  loading: boolean;
  activeTab: ModalTab;
  orderDetails: any;
  orderReview: ManagerOrderReviewRow[];
  scans: ScanFile[];
  cancelReason: string;
  designers: any[];
  millings: any[];
  deliveryPartners: any[];
  isDesignAcceptanceOverdue: boolean;
  isMillingAcceptanceOverdue: boolean;
  isDesignerRejected: boolean;
  isMillingRejected: boolean;
  selectedOrder: ManagerOrderRow | null;
  onViewStl: (scan: ScanFile) => void;
  onReassignDesigner: (
    caseId: number,
    designerId: number
  ) => Promise<boolean> | void;

  onReassignMilling: (
    caseId: number,
    millingId: number
  ) => Promise<boolean> | void;
   onReassignDelivery: (
    caseId: number,
    deliveryPartnerId: number
  ) => Promise<boolean> | void;
  onCancelOrder: (caseId: number, reason: string) => void;
  onCancelReasonChange: (reason: string) => void;
}




const formatExpectedDelivery = (value?: string | number) => {
  if (!value) return "--";

  // If value looks like minutes / duration
  if (typeof value === "number" && value < 1_000_000_000) {
    return `${value} min`;
  }

  const d = new Date(value);
  return isNaN(d.getTime()) ? "--" : d.toLocaleString("en-IN");
};
const ModalBody: React.FC<ModalBodyProps> = ({
  loading,
  activeTab,
  orderDetails,
  orderReview,
  scans,
  cancelReason,
  designers,
  millings,
  deliveryPartners,
  isDesignAcceptanceOverdue,
  isMillingAcceptanceOverdue,
  isDesignerRejected,
  isMillingRejected,
  selectedOrder,
  onViewStl,
  onReassignDesigner,
  onReassignMilling,
  onCancelOrder,
  onCancelReasonChange,
  onReassignDelivery,
}) => {
  if (loading) {
    return (
      <div className="text-center p-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <ModalBodyContent
      activeTab={activeTab}
      orderDetails={orderDetails}
      orderReview={orderReview}
      scans={scans}
      cancelReason={cancelReason}
      isDesignAcceptanceOverdue={isDesignAcceptanceOverdue}
      isMillingAcceptanceOverdue={isMillingAcceptanceOverdue}
      isDesignerRejected={isDesignerRejected}
      isMillingRejected={isMillingRejected}
      selectedOrder={selectedOrder}
      onViewStl={onViewStl}
      designers={designers}
      millings={millings}
         deliveryPartners={deliveryPartners}
  onReassignDelivery={onReassignDelivery}
      onReassignDesigner={onReassignDesigner}
      onReassignMilling={onReassignMilling}
      
      onCancelOrder={onCancelOrder}
      onCancelReasonChange={onCancelReasonChange}
    />
  );
};

interface ModalBodyContentProps extends Omit<ModalBodyProps, 'loading'> { }

const ModalBodyContent: React.FC<ModalBodyContentProps> = (props) => {
  const {
    activeTab,
    orderDetails,
    orderReview,
    scans,
    cancelReason,
    isDesignAcceptanceOverdue,
    isMillingAcceptanceOverdue,
    isDesignerRejected,
    isMillingRejected,
    selectedOrder,
    designers,
    millings,
    deliveryPartners,
    onViewStl,
    onReassignDesigner,
    onReassignMilling,
    onReassignDelivery,
    onCancelOrder,
    onCancelReasonChange,
  } = props;

  switch (activeTab) {
    case "order-status":
      return <OrderStatusContent orderDetails={orderDetails} />;
    case "order-review":
      return (
        <OrderReviewContent
          orderReview={orderReview}
          scans={scans}
          onViewStl={onViewStl}
        />
      );
    case "actions":
      return (
        <ActionsContent
          isDesignAcceptanceOverdue={isDesignAcceptanceOverdue}
          isMillingAcceptanceOverdue={isMillingAcceptanceOverdue}
          isDesignerRejected={isDesignerRejected}
          isMillingRejected={isMillingRejected}
          selectedOrder={selectedOrder}
          designers={designers}
          millings={millings}
          deliveryPartners={deliveryPartners}
          cancelReason={cancelReason}
          onReassignDesigner={onReassignDesigner}
          onReassignMilling={onReassignMilling}
           onReassignDelivery={onReassignDelivery} 
          onCancelOrder={onCancelOrder}
          onCancelReasonChange={onCancelReasonChange}
          orderDetails={orderDetails}
        />
      );
    default:
      return null;
  }
};